import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { HomesliderService } from './../../Services/homeslider.service';
import { MessagePanelService } from './../../Services/message-panel.service';
import { Globals } from './../../global';
import { LocalStorageService } from './../../Services/local-storage.service';
import { Router } from '@angular/router';
import imageCompression from 'browser-image-compression';

@Component({
  selector: 'app-homeslider',
  templateUrl: './homeslider.component.html',
  styleUrls: ['./homeslider.component.scss']
})
export class HomesliderComponent implements OnInit {

  modalRef: BsModalRef;
  public data : any;
  deleteData:any = {};
  sliderlistgetall:any =[];
  imgbaseurl="";
  defaultImage: any = '';
  imagename: any;
  // fileToUpload: File = null;
  eventImages:any = [];
  fileToUpload:any = [];

  sliderform = this.formBuilder.group({
    title: ['', Validators.required],
    status: ['', [Validators.required]],
    file:"",
  });

  sliderformEdit = this.formBuilder.group({
    title: ['', Validators.required],
    status: ['', [Validators.required]],
    file:"",
  });


  constructor(public globals: Globals, private router: Router, private formBuilder: FormBuilder, private messagePanelService: MessagePanelService, private localStorageService: LocalStorageService, public homesliderService:HomesliderService,private modalService: BsModalService) { }

  ngOnInit() {    
    this.imgbaseurl=this.localStorageService.getBaseUrl();
    this.getslideralldata();
  }

  async addSliders() {
    this.sliderform.controls['file'].setValue(this.fileToUpload);
    let title = this.sliderform.controls['title'].value?this.sliderform.controls['title'].value:'';
    let status = this.sliderform.controls['status'].value?this.sliderform.controls['status'].value:'0';
    let image = this.sliderform.controls['file'].value;
    if (!title) {
      this.messagePanelService.ShowPopupMessageWithLocalization("Please Enter Title", this.globals.messageCloseTime, this.globals.messageType.error);
      return false;
    } else if(!status) {
      this.messagePanelService.ShowPopupMessageWithLocalization("Please Select Status", this.globals.messageCloseTime, this.globals.messageType.error);
      return false;
    }else if(!image){
      this.messagePanelService.ShowPopupMessageWithLocalization("Please Choose Slider Image", this.globals.messageCloseTime, this.globals.messageType.error);
      return false;

    }else {

      let obj=null;
      if(image!= null && image!=""){
        obj= {"title": title, "status": status,"image":image};
      }else{
      obj= {"title": title, "status": status};
      }

      let form_data = await  new FormData();
      for ( var key in obj ) {
         await form_data.append(key, obj[key]);
      }
      
      console.log("Slider ADD form_data___________",form_data);
      this.homesliderService.slideradd(form_data).subscribe(data => {
        if (data === null || data === undefined) {
          this.messagePanelService.ShowPopupMessageWithLocalization('An error occured, please try again later', this.globals.messageCloseTime, this.globals.messageType.error);
        } else if (data['success'] == true) {
          console.log("Slider ADD___________",data);
          this.modalRef.hide();
          this.sliderform.reset();
          this.messagePanelService.ShowPopupMessageWithLocalization("Slider Successfully Added", this.globals.messageCloseTime, this.globals.messageType.success);
          setTimeout(()=>{ 
            this.getslideralldata();
            this.defaultImage='';
            this.fileToUpload=null;
        }, 1000);

        } else if (data['statusCode'] == 400) {
          this.messagePanelService.ShowPopupMessageWithLocalization(data['message'], this.globals.messageCloseTime, this.globals.messageType.success);
        } else {
          this.messagePanelService.ShowPopupMessageWithLocalization(data['message'], this.globals.messageCloseTime, this.globals.messageType.error);
        }
      });
    }
  }

  async onChangeSetImagePath(event) {
    const reader = new FileReader();
    const file = event.target.files[0];
    console.log("file",file);
    console.log(`originalFile size ${file.size / 1024 / 1024} MB`);
  
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    }
    try {
      const compressedFile = await imageCompression(file, options);
      console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
      this.fileToUpload = compressedFile;
      console.log("fileToUpload",this.fileToUpload);
      //--------------------
      const img = new Image();
      img.src = window.URL.createObjectURL( file );
          
      reader.readAsDataURL(file);
            reader.onload = () => {
              const width = img.naturalWidth;
              const height = img.naturalHeight;
              window.URL.revokeObjectURL( img.src );
              this.defaultImage = reader.result;
      };
      // ---------
    } catch (error) {
      console.log(error);
    }
  }

  // onChangeSetImagePath(event){
  //   const reader = new FileReader();
  //   if (event.target.files && event.target.files.length > 0) {
  //       let file = event.target.files[0];
  //       this.imagename = file.name;
  //       console.log(" this.imagename", this.imagename);
  //       const img = new Image();
  //       img.src = window.URL.createObjectURL( file );
      
  //       this.fileToUpload=file;
  //       console.log(" this.fileToUpload", this.fileToUpload);
  //       reader.readAsDataURL(file);
  //       reader.onload = () => {
  //         const width = img.naturalWidth;
  //         const height = img.naturalHeight;
  //         window.URL.revokeObjectURL( img.src );
  //         this.defaultImage = reader.result;
  //     };
  //   }
  // }
  
  getslideralldata(){
    console.log("get All Slider___")
    this.homesliderService.getsliderall().subscribe(data => {
      if (data === null || data === undefined) {
        this.messagePanelService.ShowPopupMessageWithLocalization('An error occured, please try again later', this.globals.messageCloseTime, this.globals.messageType.error);
      } else if (data['success'] === true) {
        console.log("come success____",data);
        if(data.slider.length>0){
          this.sliderlistgetall = data.slider;
        }else{
          this.sliderlistgetall = data.slider;
          this.messagePanelService.ShowPopupMessageWithLocalization(data['message'], this.globals.messageCloseTime, this.globals.messageType.success);
        }
      } else if (data['statusCode'] == 400) {
        this.messagePanelService.ShowPopupMessageWithLocalization(data['message'], this.globals.messageCloseTime, this.globals.messageType.success);
      } else {
        this.messagePanelService.ShowPopupMessageWithLocalization(data['message'], this.globals.messageCloseTime, this.globals.messageType.error);
      }
    });
  }

  
  openEditModal(template: TemplateRef<any>, slider) {
    this.defaultImage = slider.image?this.localStorageService.getBaseUrl()+slider.image:'';
    this.fileToUpload = slider.image;
    console.log("EDIT OpEN",this.fileToUpload);
    console.log("SLIDER EDit defaultImage__________",this.defaultImage)
      this.sliderformEdit = this.formBuilder.group({
      id: [slider.slide_id],
      title: [slider.title, Validators.required],
      status: [slider.status.toString(), Validators.required],
      file:"",
    });

    this.modalRef = this.modalService.show(template, {
      class:'modal-lg',
      keyboard: false,
      backdrop:'static'
    });
  }

  async editSlider(){
    console.log("EDIT______",this.fileToUpload);
    this.sliderformEdit.controls['file'].setValue(this.fileToUpload);
    let id = this.sliderformEdit.controls['id'].value;
    let title = this.sliderformEdit.controls['title'].value;
    let status = this.sliderformEdit.controls['status'].value;
    let image = this.sliderformEdit.controls['file'].value;
    if (!title) {
      this.messagePanelService.ShowPopupMessageWithLocalization("Please Enter Title", this.globals.messageCloseTime, this.globals.messageType.error);
      return false;
    } else if(!status) {
      this.messagePanelService.ShowPopupMessageWithLocalization("Please Select Status", this.globals.messageCloseTime, this.globals.messageType.error);
      return false;
    }else if(!image){
      this.messagePanelService.ShowPopupMessageWithLocalization("Please Choose Slider Image", this.globals.messageCloseTime, this.globals.messageType.error);
      return false;

    }else {

      let obj=null;
      if(image!= null && image!=""){
        obj= {"title": title, "status": status,"image":image};
      }else{
      obj= {"title": title, "status": status};
      }
      

    let form_data = await  new FormData();
    for ( var key in obj ) {
        await form_data.append(key, obj[key]);
    }
    let data ={
      id:id,
      form_data:form_data
    }
    this.homesliderService.putslider(data).subscribe(data => {
      if (data === null || data === undefined) {
        this.messagePanelService.ShowPopupMessageWithLocalization('An error occured, please try again later', this.globals.messageCloseTime, this.globals.messageType.error);
      } else if (data['success'] == true) { 
        console.log("EDIT SLIDER_________",data);
        this.modalRef.hide();
        this.sliderformEdit.reset();
        this.messagePanelService.ShowPopupMessageWithLocalization("Slider Successfully Updated", this.globals.messageCloseTime, this.globals.messageType.success);
        setTimeout(()=>{ 
          this.getslideralldata();
          this.defaultImage='';
          this.fileToUpload=null;
        }, 1000);

      } else if (data['statusCode'] == 400) {
        this.messagePanelService.ShowPopupMessageWithLocalization(data['message'], this.globals.messageCloseTime, this.globals.messageType.success);
      } else {
        this.messagePanelService.ShowPopupMessageWithLocalization(data['message'], this.globals.messageCloseTime, this.globals.messageType.error);
      }
    });
    }
  }

  deletesliders(data) {
    console.log('Delete Sllider data DONE_________',data);
    this.homesliderService.deletesliderdata(data).subscribe(data => {
      if (data === null || data === undefined) {
        this.messagePanelService.ShowPopupMessageWithLocalization('An error occured, please try again later', this.globals.messageCloseTime, this.globals.messageType.error);
      } else if (data['success'] == true) { 
        console.log("Slider DELETE SUccessfully_________",data)
        this.messagePanelService.ShowPopupMessageWithLocalization("Slider Successfully Deleted", this.globals.messageCloseTime, this.globals.messageType.success);
        this.deleteData = {};
        this.modalRef.hide();
        setTimeout(()=>{ 
          this.getslideralldata();
        }, 1000);
      } else if (data['statusCode'] == 400) {
        this.messagePanelService.ShowPopupMessageWithLocalization(data['message'], this.globals.messageCloseTime, this.globals.messageType.success);
      } else {
        this.messagePanelService.ShowPopupMessageWithLocalization(data['message'], this.globals.messageCloseTime, this.globals.messageType.error);
      }
    });
  }

  openAddModal(template: TemplateRef<any>) {
    this.sliderform.reset();
    this.modalRef = this.modalService.show(template, {
      class:'modal-lg',
      keyboard: false,
      backdrop:'static'
    });
  }

  deletesliderModal(template: TemplateRef<any>, slider) {
    console.log("Delete DATE Slider_____",slider);
    this.deleteData = slider?slider:{};
    this.modalRef = this.modalService.show(template, {
      class:'modal-lg',
      keyboard: false,
      backdrop:'static'
    });
  }
}


